// Fortnightly fuel assessment reminder logic.
//
// The pay period runs Mon–Fri over two weeks and ends on a Friday.
// ANCHOR_PERIOD_END is a known period-end Friday used as the reference cycle.
// The reminder fires on the Monday immediately after each period-end Friday.
//
// Dismissal is stored in localStorage per period so closing the banner on
// Monday suppresses it for that whole fortnight.

const ANCHOR_PERIOD_END = new Date('2026-05-22'); // known period-end Friday

function midnight(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

// Returns the period-end Friday that the given Monday follows, or null if
// today is not a "reminder Monday" in the fortnightly cycle.
export function duePeriodEnd(today = new Date()) {
  const d = midnight(today);
  if (d.getDay() !== 1) return null; // must be a Monday

  const prevFriday = new Date(d);
  prevFriday.setDate(d.getDate() - 3);

  const anchor = midnight(ANCHOR_PERIOD_END);
  const daysDiff = Math.round((prevFriday - anchor) / 86400000);

  if (daysDiff < 0 || daysDiff % 14 !== 0) return null;
  return prevFriday;
}

const DISMISS_KEY = 'hp-fuel-reminder-dismissed';

export function isDismissed(periodEnd) {
  if (!periodEnd) return true;
  try {
    return localStorage.getItem(DISMISS_KEY) === periodEnd.toISOString().slice(0, 10);
  } catch { return false; }
}

export function dismissForPeriod(periodEnd) {
  if (!periodEnd) return;
  try {
    localStorage.setItem(DISMISS_KEY, periodEnd.toISOString().slice(0, 10));
  } catch {}
}
